var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#cecdcd;stroke-width:0.5px;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#cecdcd;}.cls-5{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.34,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.12,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "cls-4",
    cx: 0.81,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    className: "cls-4",
    cx: 0.81,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    className: "cls-4",
    cx: 0.81,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    className: "cls-4",
    cx: 0.81,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    className: "cls-4",
    cx: 0.81,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    className: "cls-4",
    cx: 0.81,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    className: "cls-4",
    cx: 0.81,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    className: "cls-4",
    cx: 0.81,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    className: "cls-4",
    cx: 0.81,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    className: "cls-4",
    cx: 0.81,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    className: "cls-4",
    cx: 4.65,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    className: "cls-4",
    cx: 4.65,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    className: "cls-4",
    cx: 4.65,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    className: "cls-4",
    cx: 4.65,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    className: "cls-4",
    cx: 4.65,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    className: "cls-4",
    cx: 4.65,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    className: "cls-4",
    cx: 4.65,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    className: "cls-4",
    cx: 4.65,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    className: "cls-4",
    cx: 4.65,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    className: "cls-4",
    cx: 4.65,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    className: "cls-4",
    cx: 8.49,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    className: "cls-4",
    cx: 8.49,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    className: "cls-4",
    cx: 8.49,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    className: "cls-4",
    cx: 8.49,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    className: "cls-4",
    cx: 8.49,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    className: "cls-4",
    cx: 8.49,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    className: "cls-4",
    cx: 8.49,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    className: "cls-4",
    cx: 8.49,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    className: "cls-4",
    cx: 8.49,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    className: "cls-4",
    cx: 8.49,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    className: "cls-4",
    cx: 12.33,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    className: "cls-4",
    cx: 12.33,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    className: "cls-4",
    cx: 12.33,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    className: "cls-4",
    cx: 12.33,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    className: "cls-4",
    cx: 12.33,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    className: "cls-4",
    cx: 12.33,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    className: "cls-4",
    cx: 12.33,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    className: "cls-4",
    cx: 12.33,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    className: "cls-4",
    cx: 12.33,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    className: "cls-4",
    cx: 12.33,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    className: "cls-4",
    cx: 16.16,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    className: "cls-4",
    cx: 16.16,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    className: "cls-4",
    cx: 16.16,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    className: "cls-4",
    cx: 16.16,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    className: "cls-4",
    cx: 16.16,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    className: "cls-4",
    cx: 16.16,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    className: "cls-4",
    cx: 16.16,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    className: "cls-4",
    cx: 16.16,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    className: "cls-4",
    cx: 16.16,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    className: "cls-4",
    cx: 16.16,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    className: "cls-4",
    cx: 20,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    className: "cls-4",
    cx: 20,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    className: "cls-4",
    cx: 20,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    className: "cls-4",
    cx: 20,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    className: "cls-4",
    cx: 20,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    className: "cls-4",
    cx: 20,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    className: "cls-4",
    cx: 20,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    className: "cls-4",
    cx: 20,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    className: "cls-4",
    cx: 20,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    className: "cls-4",
    cx: 20,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    className: "cls-4",
    cx: 23.84,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    className: "cls-4",
    cx: 23.84,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    className: "cls-4",
    cx: 23.84,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    className: "cls-4",
    cx: 23.84,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    className: "cls-4",
    cx: 23.84,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    className: "cls-4",
    cx: 23.84,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    className: "cls-4",
    cx: 23.84,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    className: "cls-4",
    cx: 23.84,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    className: "cls-4",
    cx: 23.84,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    className: "cls-4",
    cx: 23.84,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    className: "cls-4",
    cx: 27.67,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    className: "cls-4",
    cx: 27.67,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    className: "cls-4",
    cx: 27.67,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    className: "cls-4",
    cx: 27.67,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    className: "cls-4",
    cx: 27.67,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    className: "cls-4",
    cx: 27.67,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    className: "cls-4",
    cx: 27.67,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    className: "cls-4",
    cx: 27.67,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    className: "cls-4",
    cx: 27.67,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    className: "cls-4",
    cx: 27.67,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    className: "cls-4",
    cx: 31.51,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    className: "cls-4",
    cx: 31.51,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    className: "cls-4",
    cx: 31.51,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    className: "cls-4",
    cx: 31.51,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    className: "cls-4",
    cx: 31.51,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    className: "cls-4",
    cx: 31.51,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    className: "cls-4",
    cx: 31.51,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    className: "cls-4",
    cx: 31.51,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    className: "cls-4",
    cx: 31.51,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    className: "cls-4",
    cx: 31.51,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    className: "cls-4",
    cx: 35.35,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    className: "cls-4",
    cx: 35.35,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    className: "cls-4",
    cx: 35.35,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    className: "cls-4",
    cx: 35.35,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    className: "cls-4",
    cx: 35.35,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    className: "cls-4",
    cx: 35.35,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    className: "cls-4",
    cx: 35.35,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    className: "cls-4",
    cx: 35.35,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    className: "cls-4",
    cx: 35.35,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    className: "cls-4",
    cx: 35.35,
    cy: 39.19,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    className: "cls-4",
    cx: 39.19,
    cy: 0.81,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    className: "cls-4",
    cx: 39.19,
    cy: 5.08,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    className: "cls-4",
    cx: 39.19,
    cy: 9.34,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    className: "cls-4",
    cx: 39.19,
    cy: 13.6,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    className: "cls-4",
    cx: 39.19,
    cy: 17.87,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    className: "cls-4",
    cx: 39.19,
    cy: 22.13,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    className: "cls-4",
    cx: 39.19,
    cy: 26.4,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    className: "cls-4",
    cx: 39.19,
    cy: 30.66,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    className: "cls-4",
    cx: 39.19,
    cy: 34.92,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    className: "cls-4",
    cx: 39.19,
    cy: 39.19,
    r: 0.65
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 66.29,
    y1: -18.8,
    x2: 23.38,
    y2: 24.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 72.27,
    y1: -12.82,
    x2: 29.36,
    y2: 30.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.26,
    y1: -6.83,
    x2: 35.35,
    y2: 36.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.3042a35b0f678ce1f72172760169de52.svg";
export { ForwardRef as ReactComponent };